<template>
  <div>
    <h2>Платежи по договору займа можно внести любым из перечисленных способов:</h2>
    <p>ВАЖНО! Номер договора займа должен содержать 8 знаков – 00123456</p>
    <ul>
      <li>
        <div>
          <div>1</div>
          <span>В сети салонов связи и пунктах обслуживания сервиса «Золотая корона» – без комиссии:</span>
        </div>
        <div class="imageLine">
          <img :src="img1_1" alt="">
          <img :src="img1_2" alt="">
          <img :src="img1_3" alt="">
          <img :src="img1_4" alt="">
        </div>
        <p>Для внесения платежа Вам потребуется паспорт, ФИО заемщика, номер договора займа. Сотрудник
          торговой сети может спросить у Вас БИК или идентификатор для корректного поиска услуги (БИК
          045004641; Идентификатор ФИНМОЛЛ 060421043).
        </p>
        <p>ВАЖНО! Номер договора займа должен содержать 8 знаков – 00123456</p>
      </li>
      <li>
        <div>
          <div>2</div>
          <span>Оплатить через сеть терминалов «Элекснет», «Amigo» и «TelePay» - без комиссии:</span>
        </div>
        <div class="imageLine">
          <img :src="img3_1" alt="">
          <img :src="img3_2" alt="">
          <img :src="img3_3" alt="">
        </div>
        <p>Для внесения платежа Вам потребуется номер договора займа – 8 знаков.</p>
      </li>
      <li>
        <div>
          <div>3</div>
          <span>В магазинах kari и kari KIDS – без комиссии:</span>
        </div>
        <div class="imageLine">
          <img :src="img4_1" alt="">
          <img :src="img4_2" alt="">
        </div>
        <p>Для внесения платежа Вам потребуется назвать кассиру номер договора займа – 8 знаков.</p>
      </li>
      <li>
        <div>
          <div>4</div>
          <span>Оплатить онлайн на сайте Золотая корона <a href="https://koronapay.com/">https://koronapay.com/</a> через вкладку «Погашение кредита»</span>
        </div>
      </li>
      <li>
        <div>
          <div>5</div>
          <span>Оплатить банковской картой на сайте ООО МКК «ФИНМОЛЛ» - <a href="https://finmoll.com">https://finmoll.com</a></span>
        </div>
      </li>
      <li>
        <div>
          <div>6</div>
          <span>По банковским реквизитам ООО МКК «ФИНМОЛЛ»</span>
        </div>
        <div class="imageLine">
          <img :src="img6" alt="">
          <div>
            <p><b>Комиссия:</b> устанавливается банком, в соответствии с действующими тарифами</p>
            <p><b>Зачисление:</b> от 3 до 5 банковских дней</p>
            <p><b>Необходимо:</b></p>
            <ul id="sberUl">
              <li>Номер договора займа и ФИО заемщика</li>
              <li>Реквизиты ООО МКК «ФИНМОЛЛ»</li>
            </ul>
          </div>
        </div>
        <p>Для перевода через Сбербанк России Вам необходимо указать реквизиты ООО МКК «ФИНМОЛЛ»</p>
        <table>
          <tr>
            <td>Получатель платежа</td>
            <td> ООО МКК «ФИНМОЛЛ»</td>
          </tr>
          <tr>
            <td>Банк получателя</td>
            <td>ПАО Сбербанк</td>
          </tr>
          <tr>
            <td>БИК</td>
            <td>044525225</td>
          </tr>
          <tr>
            <td> ИНН </td>
            <td>7705954143</td>
          </tr>
          <tr>
            <td>КПП</td>
            <td>540101001</td>
          </tr>
          <tr>
            <td>ОГРН/ОГРНИП</td>
            <td>1117746509638</td>
          </tr>
          <tr>
            <td>Кор. счет</td>
            <td>30101810400000000225</td>
          </tr>
          <tr>
            <td>Расчетный счет</td>
            <td>40701810738000002048</td>
          </tr>
          <tr>
            <td>Назначение платежа</td>
            <td>Погашение займа по договору № ХХХХХХХХ (8 знаков), Иванов Иван</td>
          </tr>
        </table>
      </li>
    </ul>
  </div>
</template>

<script>
  import img3_1 from '@/assets/images/eleksnet.png';
  import img3_2 from '@/assets/images/amigo.png';
  import img3_3 from '@/assets/images/tepepay.png';
  import img4_1 from '@/assets/images/kari1.png';
  import img4_2 from '@/assets/images/kari2.png';
  import img1_1 from '@/assets/images/megafon.png';
  import img1_2 from '@/assets/images/evroset.jpg';
  import img1_3 from '@/assets/images/Beeline_logo.jpg';
  import img1_4 from '@/assets/images/logo-svyaznoy.jpg';
  import img6 from '@/assets/images/sber.jpg';

  export default {
    name: "Requirements",
    data(){
      return{
        img3_1,
        img3_2,
        img3_3,
        img4_1,
        img4_2,
        img1_1,
        img1_2,
        img1_3,
        img1_4,
        img6,
      }
    }
  }
</script>

<style scoped>
ul{}
ul > li{margin: 5vw 0;}
ul > li > div:first-child{}
ul > li > div:first-child {display: flex;align-items: center;justify-content: flex-start;}
ul > li > div:first-child > div:first-child{display: flex;align-items: center;justify-content: center;background:
  #42AB34;color:white;border-radius: 100%;width: 10vw;height: 10vw;}
ul > li > div:first-child > span {width: calc(100% - 20vw);margin-left: 5vw;font-weight: bold;}
ul > li > div:first-child > span > a{color:#0D5A44;font-weight: bold}
.imageLine{display: flex;align-items: center;justify-content: center;flex-wrap: wrap}
#sberUl{}
#sberUl li{list-style: disc;margin: 5vw}
.content p {margin: 1vw 0;}
@media screen and (min-width: 760px) {
  ul{}
  ul > li{margin: 2vw 0;}
  ul > li > div:first-child{}
  ul > li > div:first-child{}
  ul > li > div:first-child > div:first-child{width: 2.8vw;height: 2.8vw;}
  ul > li > div:first-child > span{width: calc(100% - 5vw);margin-left: 1vw;}
  ul > li > div:first-child > span > a{}
  .imageLine img{margin: 0 2vw;}
  #sberUl{}
  #sberUl li{margin: 0 2vw;}
}

@media screen and (min-width: 1140px) {
  ul{}
  ul > li{margin: 30px;}
  ul > li > div:first-child{}
  ul > li > div:first-child{}
  ul > li > div:first-child > div:first-child{width: 32px;height: 32px;}
  ul > li > div:first-child > span{width: calc(100% - 50px);margin-left: 10px;}
  ul > li > div:first-child > span > a{}
  .imageLine img{margin: 0 10px;}
  #sberUl{}
  #sberUl li{margin: 10px 20px;}
}


</style>
